import {
  GET_PROMPT_CATEGORY_SUCCESS,
  GET_PROMPT_SUBCATEGORY_SUCCESS,
  GET_PROMPT_CATEGORY_FAILED,
  GET_PROMPT_SUBCATEGORY_FAILED,
  GET_PROMPT_SUCCESS,
  GET_PROMPT_FAILED,
  GET_SINGLE_PROMPT_SUCCESS,
  GET_IMAGE_GENERATION_PROMPTS_FAILURE,
  GET_IMAGE_GENERATION_PROMPTS_LOADING,
  GET_IMAGE_GENERATION_PROMPTS_SUCCESS,
  GET_CAPITOL_DATA_SUCCESS,
  GET_CAPITOL_DATA_FAILURE,
  GET_CAPITOL_CHARACTER_SUCCESS,
  GET_CAPITOL_CHARACTER_FAILURE,
} from '../types/prompt.type'

const intialState = {
  categories: null,
  subCategories: null,
  prompts: null,
  singlePrompt: null,
  loading: false,
  error: null,
  textToImagePrompts: null,
  tabOptions: null,
  capitolData: [],
  capitolCharacter: [],
}

const promptReducer = (state = intialState, action) => {
  switch (action.type) {
    case GET_PROMPT_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
      }
    case GET_PROMPT_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        subCategories: action.payload,
      }
    case GET_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
        prompts: action.payload,
      }

    case GET_SINGLE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: action.payload.loader != undefined ? action.payload.loader : true,
        singlePrompt: action.payload.loader ? null : action.payload,
      }
    case GET_PROMPT_CATEGORY_FAILED:
      return {
        ...state,
        loading: false,
        categories: null,
        error: action.payload,
      }
    case GET_PROMPT_SUBCATEGORY_FAILED:
      return {
        ...state,
        loading: false,
        subCategories: null,
        error: action.payload,
      }
    case GET_PROMPT_FAILED:
      return {
        ...state,
        loading: false,
        prompts: null,
        error: action.payload,
      }

    case GET_IMAGE_GENERATION_PROMPTS_LOADING:
      return {
        ...state,
        isGeneratingImage: true,
      }
    case GET_IMAGE_GENERATION_PROMPTS_SUCCESS:
      return {
        ...state,
        textToImagePrompts: action.payload,
        isGeneratingImage: false,
        tabOptions: Object.keys(action.payload) || null,
      }
    case GET_CAPITOL_DATA_SUCCESS:
      return {
        ...state,
        capitolData: action.payload,
      }
    case GET_CAPITOL_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CAPITOL_CHARACTER_SUCCESS:
      return {
        ...state,
        capitolCharacter: action.payload,
      }
    case GET_CAPITOL_CHARACTER_FAILURE:
      return {
        ...state,
        error: action.payload,
      }

    case GET_IMAGE_GENERATION_PROMPTS_FAILURE:
      return {
        ...state,
        isGeneratingImage: false,
      }
    default:
      return state
  }
}

export default promptReducer
